import React from "react";
import { Box, Heading } from "grommet";
import { LinkPrevious } from "grommet-icons";
import { useNavigate } from "react-router-dom";

const BreadcrumbHeader = ({ title1, title2 }) => {
  const navigate = useNavigate();

  return (
    <>
      <Box
        direction="row"
        align="center"
        gap="small"
        margin={{ horizontal: "medium", vertical: "small" }}
      >
        {/* Back Button */}
        <LinkPrevious
          size="large"
          onClick={() => navigate(-1)}
          color="brand"
          style={{ cursor: "pointer" }}
        />

        {/* Breadcrumb Heading */}
        <Box direction="row" align="center" gap="xsmall">
          <Box style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
            <Heading level="2" margin="none">
              {title1}
            </Heading>
          </Box>
          <Heading level="2" margin="none">
            / {title2}
          </Heading>
        </Box>
      </Box>

      {/* Underline */}
      <Box
        border={{ color: "brand", size: "xsmall", side: "bottom" }}
        width="full"
      />
    </>
  );
};

export default BreadcrumbHeader;